export const packageTypesOptions = [
  {
    value: 'packaged',
    label: 'Packaged',
  },
  {
    value: 'individual',
    label: 'Individual',
  },
  {
    value: 'cut to length',
    label: 'Cut to length',
  },
  {
    value: 'fixed quantity',
    label: 'Fixed Quantity',
  },
];
